export const FIRST_OFFSET = 1;
export const FILES_COUNT_PER_OFFSET = 50;
